import { useEffect, useState } from "react";

import api from "../api/axios";

let cachedCategories = null;
let pendingRequest = null;

const requestCategories = () => {
  if (cachedCategories) {
    return Promise.resolve(cachedCategories);
  }

  if (!pendingRequest) {
    pendingRequest = api
      .get("/products_customer/categories")
      .then((response) => {
        const categories = Array.isArray(response.data?.data)
          ? response.data.data
          : [];

        cachedCategories = categories;
        return categories;
      })
      .finally(() => {
        pendingRequest = null;
      });
  }

  return pendingRequest;
};

const useCatalogNavigation = () => {
  const [categories, setCategories] = useState(cachedCategories || []);
  const [loading, setLoading] = useState(!cachedCategories);

  useEffect(() => {
    let active = true;

    requestCategories()
      .then((nextCategories) => {
        if (active) {
          setCategories(nextCategories);
        }
      })
      .catch((error) => {
        console.error("Catalog navigation fetch failed:", error);

        if (active) {
          setCategories([]);
        }
      })
      .finally(() => {
        if (active) {
          setLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, []);

  return { categories, loading };
};

export default useCatalogNavigation;
